module.exports = __webpack_public_path__ + "img/punto.645a3dcf.png";